export const NASA_API_KEY = "NmkD1IjEQ5egj3b4HImH1gPM2awVjN7nmCpX6zg0";

export const NASA_APOD = "https://api.nasa.gov/planetary/apod";
